var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { DirectoryType } from 'vrlcm-gui-types';
export var directoryTypeToFriendlyText = function (l10n, directoryType) {
    switch (directoryType) {
        case DirectoryType.ACTIVE_DIRECTORY_LDAP:
            return l10n('authzn.dirmgmt.activeDirOverLdap');
        case DirectoryType.ACTIVE_DIRECTORY_IWA:
            return l10n('authzn.dirmgmt.activeDirWithIwa');
        case DirectoryType.JIT_DIRECTORY:
            return l10n('authzn.dirmgmt.jitDir');
        case DirectoryType.OTHER_DIRECTORY:
            return l10n('authzn.dirmgmt.otherDir');
        case DirectoryType.OPEN_LDAP:
            return l10n('authzn.dirmgmt.openLdap');
        case DirectoryType.CLOUD_DIRECTORY:
            return l10n('authzn.dirmgmt.cloudDir');
        case DirectoryType.LOCAL_DIRECTORY:
            return l10n('authzn.dirmgmt.localDir');
        default:
            return directoryType;
    }
};
export function getDirectorySearchAttributes() {
    return ['sAMAccountName', 'userPrincipalName'];
}
export var groupMappingItemKey = function (groupMI) {
    return groupMI.mappedGroup.dn;
};
export var getDefaultUserAttributeDefinition = function (label, name) { return ({
    label: label,
    name: name,
    permanent: false,
    readOnly: false,
    required: false,
    sensitive: false
}); };
export var sortUserAttributeDefinition = function (items) {
    return __spreadArrays(items.filter(function (i) { return i.permanent && i.required; }), items.filter(function (i) { return i.permanent && !i.required; }), items.filter(function (i) { return !i.permanent; }));
};
export var mapAlertItem = function (alert) {
    return {
        message: alert.formattedMessage
            ? alert.formattedMessage
            : alert.alertType + " : " + alert.alertMessageKey + " : " + alert.keyArgs.join(', '),
        level: alert.alertLevel === 'WARNING' ? 'warning' : 'danger'
    };
};
export var sumAllSubGroups = function (groups) {
    return groups ? groups.length : 0;
};
export var flattenGroups = function (l10n, groupInfo) {
    return Object.entries(groupInfo).reduce(function (finalList, _a) {
        var groupDN = _a[0], mappedSubGroup = _a[1];
        return finalList.concat(mappedSubGroup.selected
            ? [
                {
                    groupDN: groupDN,
                    mappedGroup: l10n('authzn.dirmgmt.allGroupsInDnAreSelected')
                }
            ]
            : mappedSubGroup.mappedGroupData
                .filter(function (g) { return g.selected; })
                .map(function (g) { return ({
                groupDN: groupDN,
                mappedGroup: g.mappedGroup.dn
            }); }));
    }, []);
};
